export default "__VITE_ASSET__BZx2Shxv__"